import { moleculeHeadingFields } from 'molecules/Heading/config';
import imageField from 'molecules/Image/config';
import sectionFields from 'molecules/Section/config';

import type { Component, Input } from '@builder.io/sdk';

const speakerCardsFields = [
  {
    name: 'heading',
    type: 'object',
    subFields: moleculeHeadingFields,
    helperText: 'Heading block shown beside the speaker grid (e.g. "Speakers" plus an intro paragraph).',
  },
  {
    name: 'speakers',
    type: 'list',
    helperText: 'Add one or more speakers. Leave the photo empty to show a "to be announced" placeholder.',
    subFields: [
      { name: 'id', type: 'string', required: true, showIf: 'false' },
      imageField('photo'),
      {
        name: 'name',
        type: 'string',
        required: true,
        defaultValue: 'Speaker name',
        helperText: 'Full name of the speaker (required).',
      },
      {
        name: 'title',
        type: 'string',
        helperText: 'Role and company, e.g. "CEO and Co-Founder at Prismatic" (optional).',
      },
    ],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    onChange: (options: Map<string, any>) => {
      options.get('speakers').forEach((item: Map<string, string>, index: number) => {
        item.set('id', `speaker-${index}`);
      });
    },
  },
  {
    name: 'andMoreText',
    type: 'string',
    defaultValue: '… and more!',
    helperText: 'Text shown in the empty slot after the cards (e.g. "… and more!"). Leave empty to hide it.',
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const speakerCardsConfig = {
  name: 'SpeakerCards',
  inputs: speakerCardsFields,
} satisfies Component;

export type SpeakerCardsConfigProps = GenerateBuilder<typeof speakerCardsFields>;

export default speakerCardsConfig;
